<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.page')"
    namespace="/"
    resource="pages"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/pages.js';

@Component
export default class Pages extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'title_cont',
      'slug_cont'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'title',
      'slug',
      {
        key: 'type',
        label: this.$t('page.presetPage'),
        renderCell: (h, { props: { value } }) => {
          let tagType
          let text

          if (value === 'PresetPage') {
            tagType = 'success'
            text = this.$t('bean.yes')
          } else {
            tagType = 'danger'
            text = this.$t('bean.no')
          }

          return <el-tag type={tagType}>{text}</el-tag>;
        }
      },
      'status',
      type === 'show' && 'mini_program_path',
      type === 'show' && 'content',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at'
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type } = {}) {
    const array = [
      'title',
      'slug',
      data.type !== 'PresetPage' && 'status',
      'content'
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'pages.edit', params: { id: row.id } }
        }
      },
      row.type === 'StaticPage' && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'pages.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/pages',
    name: 'pages.index',
    component: Pages,
    props: {
      type: 'index',
    }
  },
  {
    path: '/pages/new',
    name: 'pages.new',
    component: Pages,
    props: {
      type: 'new',
    }
  },
  {
    path: '/pages/:id',
    name: 'pages.show',
    component: Pages,
    props: {
      type: 'show',
    }
  },
  {
    path: '/pages/:id/edit',
    name: 'pages.edit',
    component: Pages,
    props: {
      type: 'edit'
    }
  }
]
</script>
